import { TOGGLE_CITY_INFORMATIONS_DETAIL_PANEL } from "./displayCityInformationsDetailsPanelReducer"

export const toggleCityInformationDetailsPanel = () => ({
    type: TOGGLE_CITY_INFORMATIONS_DETAIL_PANEL,
})